import { IAttributeGroup } from "@/services/Models";
import { computed, ref } from "vue";

const orderConsts = {
  attrGroupIDs: [
    // 優先キーの属性グループID
    4, //  第一優先キー:タッチ
    1, //  第二優先キー:登場人物
  ],
  attrIDs: [
    // 優先キーの属性ID
    [18, 20], // 第一優先キー:男性マンガ, 劇画調
    [6, 7], // 第二優先キー:男性と女性, 男性のみ
  ],
};
export enum AuthorOrder {
  ASC, // 昇順
  DESC, // 降順
}

export const useSelectAttribute = (
  attributeGroups: IAttributeGroup[],
  init: number[] = []
) => {
  // 属性グループと所属する属性のうち選択された属性のセット
  const groupWithList = attributeGroups.map((x) => ({
    group: x,
    selectedList: ref(
      x.attributes.filter((a) => init.includes(a.id)).map((a) => a.id)
    ),
  }));
  // 選択された属性ID群
  const selectedAttributeIDs = computed(() =>
    groupWithList.map((x) => x.selectedList.value).flat()
  );
  const authorOrder = (): AuthorOrder => {
    for (let i = 0; i < orderConsts.attrGroupIDs.length; i++) {
      // 属性グループ検索
      const attrGroup = groupWithList.find(
        (x) => x.group.id === orderConsts.attrGroupIDs[i]
      );
      if (
        attrGroup !== undefined &&
        attrGroup.selectedList.value.length !== 0
      ) {
        // 属性ID検索
        for (const attrID of orderConsts.attrIDs[i]) {
          if (attrGroup.selectedList.value.includes(attrID)) {
            return AuthorOrder.ASC;
          }
        }
        return AuthorOrder.DESC;
      }
    }
    return AuthorOrder.ASC;
  };
  return {
    groupWithList,
    selectedAttributeIDs,
    authorOrder,
  };
};
